import gql from "graphql-tag";

export const CREATE_CRM_SEQUENCE = gql`
  mutation AddCrmSequence($data: CrmSequenceDataInput) {
    addCrmSequence(data: $data) { id campaignId version }
  }
`;

export const UPDATE_CRM_SEQUENCE = gql`
  mutation UpdateCrmSequence($where: CrmSequenceWhereInput, $data: CrmSequenceDataInput) {
    updateCrmSequence(where: $where, data: $data) { id }
  }
`;

const crmSequences = { CREATE_CRM_SEQUENCE, UPDATE_CRM_SEQUENCE };
export default crmSequences;
